import PageType from '@alltrails/amplitude/enums/PageType';
import { LocationDetailsResponseType } from '@/types/locationDetailsPages/shared';

export const getAnalyticsPageType = (type?: LocationDetailsResponseType): PageType => {
  switch (type) {
    case 'poi':
      return 'poi page';
    case 'park':
      return 'park page';
    default:
      return 'location page';
  }
};
